import Forms from "@/pages/forms";

export const routeForm = "/forms";

export const formRoutes = [
	{
		path: `${routeForm}`,
		element: <Forms />,
	},
	{
		path: `${routeForm}/:formId`,
		element: <Forms />,
	},
];
